import { formatInstance } from 'models/formatters'
import { USER_BEFORE_UPDATE_HOOK } from 'models/daos/user/hooks/before-update'

const FORMATTER_MAP = {
  ...USER_BEFORE_UPDATE_HOOK
}

function formatInstanceBeforeUpdate (params) {
  return formatInstance({
    ...params,
    formatterMap: FORMATTER_MAP
  })
}

export {
  formatInstanceBeforeUpdate
}
